import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { TreeView, ITreeViewProps } from "../TreeView/TreeView";

// todo:
// component should self load data but not possible until we have API clients moved into packages
// here as a placeholder
export class AssetWorXPlusTreeView extends BaseComponent<IAssetWorXPlusTreeViewProps, IAssetWorXPlusTreeViewState>
{
    public render(): JSX.Element
    {
        return (
            <TreeView
                {...this.props}
            />
        );
    }
}

export interface IAssetWorXPlusTreeViewProps extends ITreeViewProps
{
}

export interface IAssetWorXPlusTreeViewState
{
}
